module.exports = __webpack_public_path__ + "static/media/info-market.78aba6cb.jpeg";